import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import {
  getLanguageList,
  getListCountry,
  createListSalesmen,
  updateListSalesmen,
} from "../../services/MoloniServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ConfigDB from "../../config";

const AddSalesmenMoloni = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const { uuid } = useParams();
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [salesmenData, setSalesmenData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    visibility: "",
    code: "",
    default_commission: "",
    copy_quantity_id: "",
    notes: "",
    base_commission: "",
  });

  let errorsObj = {
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [languageList, setLanguageList] = useState([]);
  const [activeCustomerTab, setActiveCustomerTab] = useState("1");
  const [countryList, setCountryList] = useState([]);
  const [altForm, setAltForm] = useState({
    description: "",
    code: "",
    address: "",
    zip_code: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    fax: "",
    contact_person: "",
  });

  const handleAltChange = (e) => {
    setAltForm({
      ...altForm,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (state) {
      setSalesmenData({
        id: state?.id,
        vat: state?.vat,
        number: state?.number,
        name: state?.name,
        language_id: state?.language_id,
        qty_copies_document: state?.qty_copies_document,
        notes: state?.notes,
        country_id: state?.country_id,
        address: state?.address,
        zip_code: state?.zip_code,
        city: state?.city,
        email: state?.email,
        website: state?.website,
        phone: state?.phone,
        contact_name: state?.contact_name,
        contact_email: state?.contact_email,
        contact_phone: state?.contact_phone,
        discount: state?.discount,
        credit_limit: state?.credit_limit,
        payment_method_id: state?.payment_method_id,
        delivery_method_id: state?.delivery_method_id,
        maturity_date_id: state?.maturity_date_id,
        field_notes: state?.field_notes,
        moloni_id: state?.moloni_id,
        fax: state?.fax,
        salesman_id: state?.salesman_id,
        price_class_id: state?.price_class_id,
        payment_day: state?.payment_day,
        document_type_id: state?.document_type_id,
        base_commission: state?.base_commission,
      });
    }
  }, [state]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();

    if (!salesmenData.vat) {
      toast.error("Vat is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.number) {
      toast.error("Number is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.name) {
      toast.error("Name is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.language_id) {
      setActiveCustomerTab("4");
      toast.error("Language is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.address) {
      toast.error("Address is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.zip_code) {
      toast.error("Zip Code is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.country_id) {
      toast.error("Country is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData.email) {
      toast.error("Email is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!salesmenData?.base_commission) {
      toast.error("Base Commission is required.");
      setActiveCustomerTab("2");
      setIsModifyButtonLoad(false);
      return;
    }
    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      vat: salesmenData?.vat,
      number: salesmenData?.number,
      name: salesmenData?.name,
      language_id: salesmenData?.language_id,
      qty_copies_document: salesmenData?.qty_copies_document,
      notes: salesmenData?.notes,
      country_id: salesmenData?.country_id,
      address: salesmenData?.address,
      zip_code: salesmenData?.zip_code,
      city: salesmenData?.city,
      email: salesmenData?.email,
      website: salesmenData?.website,
      phone: salesmenData?.phone,
      fax: salesmenData?.fax,
      contact_name: salesmenData?.contact_name,
      contact_email: salesmenData?.contact_email,
      contact_phone: salesmenData?.contact_phone,
      discount: salesmenData?.discount,
      credit_limit: salesmenData?.credit_limit,
      payment_method_id: salesmenData?.payment_method_id,
      delivery_method_id: salesmenData?.delivery_method_id,
      maturity_date_id: salesmenData?.maturity_date_id,
      field_notes: salesmenData?.field_notes,
      salesman_id: salesmenData?.salesman_id,
      price_class_id: salesmenData?.price_class_id,
      payment_day: salesmenData?.payment_day,
      base_commission: salesmenData?.base_commission,
      document_type_id: 0,
    };

    let updateData = {
      company_id: "269134",
      salesmen_id: salesmenData?.id,
      vat: salesmenData?.vat,
      number: salesmenData?.number,
      name: salesmenData?.name,
      language_id: salesmenData?.language_id,
      qty_copies_document: salesmenData?.qty_copies_document,
      notes: salesmenData?.notes,
      country_id: salesmenData?.country_id,
      address: salesmenData?.address,
      zip_code: salesmenData?.zip_code,
      city: salesmenData?.city,
      email: salesmenData?.email,
      website: salesmenData?.website,
      phone: salesmenData?.phone,
      fax: salesmenData?.fax,
      contact_name: salesmenData?.contact_name,
      contact_email: salesmenData?.contact_email,
      contact_phone: salesmenData?.contact_phone,
      discount: salesmenData?.discount,
      credit_limit: salesmenData?.credit_limit,
      payment_method_id: salesmenData?.payment_method_id,
      delivery_method_id: salesmenData?.delivery_method_id,
      maturity_date_id: salesmenData?.maturity_date_id,
      field_notes: salesmenData?.field_notes,
      salesman_id: salesmenData?.salesman_id,
      price_class_id: salesmenData?.price_class_id,
      payment_day: salesmenData?.payment_day,
      document_type_id: 0,
      customer_id: salesmenData?.moloni_id,
      base_commission: salesmenData?.base_commission,
    };

    if (salesmenData?.id) {
      updateListSalesmen(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/salesmen");

          setIsModifyButtonLoad(false);
          setSalesmenData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createListSalesmen(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/salesmen");
          setIsModifyButtonLoad(false);

          setSalesmenData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center"></div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="card card-primary">
              <div className="card-body">
                <div className="row justify-content-start">
                  <div className="col-md-12">
                    <h5 className="page-title">SalesMen</h5>
                    <h5 className="page-title">
                      {uuid
                        ? `In this section you can change the salesmen ${salesmenData?.name}`
                        : "In this section you can insert a new salesmen"}
                    </h5>

                    <Form method={`post`} onSubmit={handleSubmitForm}>
                      <div className="row">
                        <div className="mb-3">
                          {/* Tabs */}
                          <ul className="custom-tabs">
                            <li
                              className={
                                activeCustomerTab === "1"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("1")}
                            >
                              {t("main")}
                            </li>

                            <li
                              className={
                                activeCustomerTab === "2"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("2")}
                            >
                              {t("contact")}
                            </li>
                          </ul>

                          <div className="tab-content-area">
                            {activeCustomerTab === "1" && (
                              <div className="row">
                                <div class="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>
                                <p>General Information</p>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("vat")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.vat}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            vat: e.target.value,
                                          });
                                        }}
                                        name={`vat`}
                                        maxLength={50}
                                        placeholder="Vat"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("sellerCode")}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.number}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            number: e.target.value,
                                          });
                                        }}
                                        name={`number`}
                                        maxLength={50}
                                        placeholder="Seller Code"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("Name")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.name}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            name: e.target.value,
                                          });
                                        }}
                                        name={`name`}
                                        maxLength={50}
                                        placeholder="Name"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("language")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={languageList}
                                          value={languageList.find(
                                            (item) =>
                                              item.value ==
                                              salesmenData.language_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSalesmenData({
                                              ...salesmenData,
                                              language_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Language"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("copyQuantity")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={
                                            ConfigDB?.data?.copyQuantityList
                                          }
                                          value={ConfigDB?.data?.copyQuantityList.find(
                                            (item) =>
                                              item.value ==
                                              salesmenData.qty_copies_document,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSalesmenData({
                                              ...salesmenData,
                                              qty_copies_document:
                                                selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Copy Quantity"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("notes")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <textarea
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.notes}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            notes: e.target.value,
                                          });
                                        }}
                                        name={`notes`}
                                        placeholder="Notes"
                                        rows={4}
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("base_commission")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={salesmenData.base_commission}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          if (!/^\d*\.?\d*$/.test(val)) return;

                                          setSalesmenData({
                                            ...salesmenData,
                                            base_commission: val,
                                          });
                                        }}
                                        onKeyDown={(e) => {
                                          const blockedKeys = [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            ".",
                                          ];
                                          if (blockedKeys.includes(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                        name="base_commission"
                                        maxLength={50}
                                      />
                                    </div>
                                  </FormGroup>
                                </div>{" "}
                                <div className="col-md-4" />
                                <div className="col-md-4" />
                                <div class="alert alert-primary" role="alert">
                                  Fill with default data
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("address")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <textarea
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.address}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            address: e.target.value,
                                          });
                                        }}
                                        name={`address`}
                                        maxLength={50}
                                        placeholder="Address"
                                        rows={3}
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("city")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.city}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            city: e.target.value,
                                          });
                                        }}
                                        name={`city`}
                                        maxLength={50}
                                        placeholder="City"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("zip_code")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.zip_code}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            zip_code: e.target.value,
                                          });
                                        }}
                                        name={`zip_code`}
                                        maxLength={50}
                                        placeholder="Zip code"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("country")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              item.value ==
                                              salesmenData.country_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSalesmenData({
                                              ...salesmenData,
                                              country_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4" />
                                <div className="col-md-4" />
                              </div>
                            )}

                            {activeCustomerTab === "2" && (
                              <div className="row">
                                <div class="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>

                                <p>Contacts</p>

                                <div className="col-md-4 d-none">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("geographicalArea")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              item.value ==
                                              salesmenData.country_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setSalesmenData({
                                              ...salesmenData,
                                              country_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Geographical Area"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("email")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.email}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            email: e.target.value,
                                          });
                                        }}
                                        name={`email`}
                                        maxLength={50}
                                        placeholder="Contact email"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("phone")}
                                    </Label>
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={salesmenData.phone}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            phone: e.target.value,
                                          });
                                        }}
                                        name={`phone`}
                                        placeholder="Phone"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("fax")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={salesmenData.fax}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            fax: e.target.value,
                                          });
                                        }}
                                        name={`fax`}
                                        placeholder="Fax"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("website")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={salesmenData.website}
                                        onChange={(e) => {
                                          setSalesmenData({
                                            ...salesmenData,
                                            website: e.target.value,
                                          });
                                        }}
                                        name={`website`}
                                        placeholder="website"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4" />
                                <div className="col-md-4" />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => navigate("/salesmen")}
                          >
                            <i className="bi bi-arrow-left"> </i> {t("back")}
                          </button>
                        </div>
                        <div className="col">
                          <div className="d-flex justify-content-end nxt-btn">
                            {isModifyButtonLoad ? (
                              <button type="submit" className="btn btn-primary">
                                Loading...
                              </button>
                            ) : (
                              <button type="submit" className="btn btn-primary">
                                {t("submit")} <i className="bi bi-check2"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddSalesmenMoloni;
